<div class="surveyContainer">
    <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
    <span class="sr-only">Loading...</span>
    <div class="header hdr">
        <h5><span class="animateH5">Survey Analytics</span></h5>
    </div>
    <div class="container-fluid text-record-main">
        <!-- <div class="col-md-12 text-center">
            <ul class="nav nav-pills nav-justified SurveyTag">
                <li class="nav-item ">
                    <a class="nav-link active" (click)="openDoc('survey')" role="tab" data-bs-toggle="tab"
                        data-bs-target="#survey" aria-current="page" href="#" (click)="getSurveyListData()">Survey
                        Records</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="openDoc('ivy')" role="tab" data-bs-toggle="tab" data-bs-target="#ivy"
                        href="#" (click)="getIvyListData()">IVR Survey
                        Records</a>
                </li>
            </ul>
        </div> -->
        <!-- survey records -->
        <div class="surveyRecords" id="survey" *ngIf="showData === 'survey'">
            <div class="inputContainer">
                <div class="input-group tblSelect">
                    <button class="btn btn-primary audioTableSearchBtn"><i class="fa-solid fa-magnifying-glass"></i></button>
                    <input type="text" placeholder="Search" [(ngModel)]="searchText" class="form-control">
                </div>
            </div>
            <div class="table-responsive">
                <div class="card tblCrd">
                    <table class="table table-hover text-center">
                        <thead class="tblHead ">
                            <tr class="text-center">
                                <th class="text-start">claim number</th>
                                <th>question answers</th>
                                <th>question answers average</th>
                                <th>comments sentiment</th>
                                <th>intake date</th>
                                <th>survey created date</th>
                                <th>survey completed date</th>
                                <th>action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let result of surveyTableData | search:searchText | paginate :{itemsPerPage:limit,
                                currentPage:page,
                                totalItems:surveyResult.total_records}; index as i" (click)="tableBack(i)"
                                [ngClass]="{'selectedClass':i===tableTrVar, 'unread': result.read==='N'}">
                                <td class="text-start">{{result.claim_number}}</td>
                                <td class="survey-fa-eye-table">
                                    <i class="fa fa-eye surveyTableIcons" data-bs-toggle="modal"
                                        data-bs-target="#questionAnswerModal" (click)="sendIndex(i)"
                                        tooltip="View Question Answers" placement="top" [options]="myOptions">
                                    </i>
                                </td>
                                <td class="progressTdEmailAnalytics">
                                    <div class="progress">
                                        <div [ngClass]="{'progress-bar0': result.question_answers_score_average == 0, 'progress-barGreen':result.question_answers_score_average > 74, 'progress-barRed':result.question_answers_score_average > 0 && result.question_answers_score_average < 50}"
                                            class="progress-bar" role="progressbar"
                                            attr.style="width:{{result.question_answers_score_average}}%"
                                            attr.aria-valuenow="{{result.question_answers_score_average}}"
                                            attr.aria-valuemin="{{0}}" aria-valuemax="100">
                                            {{result.question_answers_score_average
                                            |
                                            number:'1.0-0'}}%</div>
                                    </div>
                                    <!-- <i class="fa fa-eye" aria-hidden="true" tooltip="View Keyword Details"
                                        [options]="myOptions" data-bs-toggle="modal"
                                        data-bs-target="#keywordPercentageModal"
                                        (click)="getReportData(i, 'keywordPercentage')"></i> -->
                                </td>
                                <td class="text-center sentiment-icon">
                                    <span *ngIf="result.comments !== null">
                                        <i class="fa-regular fa-face-smile surveyTableIcons iconSmile"
                                            (click)="sendIndex(i)" data-bs-toggle="modal"
                                            data-bs-target="#sentimentModal" [options]="myOptions"
                                            tooltip="View Sentiment Score" placement="top"
                                            *ngIf="result.comments_sentiment?.negative_sentiment < result.comments_sentiment?.positive_sentiment && result.comments_sentiment?.sentiment === 'Positive'"></i>
                                        <i class="fa-regular fa-face-frown surveyTableIcons iconSad"
                                            (click)="sendIndex(i)" data-bs-toggle="modal"
                                            data-bs-target="#sentimentModal" [options]="myOptions"
                                            tooltip="View Sentiment Score" placement="top"
                                            *ngIf="result.comments_sentiment?.positive_sentiment < result.comments_sentiment?.negative_sentiment && result.comments_sentiment?.sentiment === 'Negative'"></i>
                                        <i class="fa-regular fa-face-meh surveyTableIcons iconMeh"
                                            (click)="sendIndex(i)" data-bs-toggle="modal"
                                            data-bs-target="#sentimentModal" tooltip="View Sentiment Score"
                                            placement="top" [options]="myOptions"
                                            *ngIf="result.comments_sentiment?.positive_sentiment === result.comments_sentiment?.negative_sentiment"></i>
                                    </span>
                                    <span *ngIf="result.comments === null">-</span>
                                </td>
                                <td class="text-center">{{result.intake_date | date:'MM-dd-yyyy'}}</td>
                                <td class="text-center">{{result.survey_created_date | date:'MM-dd-yyyy'}}</td>
                                <td class="text-center">{{result.survey_completed_date | date:'MM-dd-yyyy'}}</td>
                                <td class="actionTd">
                                    <i class="fa-solid fa-circle-info audioIcons iconAction" tooltip="File Info"
                                        [options]="myOptions"></i>
                                    <i class="fa-regular fa-trash-can audioIcons iconAction" tooltip="Delete Record"
                                        [options]="myOptions" *ngIf="usersRole !== 101"></i>
                                </td>
                            </tr>
                            <tr class="text-center" *ngIf="surveyTableData?.length === 0">
                                <td colspan="8" class="pad-10-0">
                                    <p class="mar-0">No Records here</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="paginationRecords" *ngIf="surveyTableData?.length > 0">
                <div class="row">
                    <div class="col-md-6 pagination-records">
                        <p>Showing {{surveyTableData?.length}} of {{surveyResult.total_records}} records</p>
                    </div>
                    <div class="col-md-6 text-right">
                        <div class="pgContainer">
                            <pagination-controls #pagination [maxSize]="7" [responsive]="true" [autoHide]="true"
                                [directionLinks]="true" (pageChange)="pageChanged($event)">

                            </pagination-controls>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Ivy records -->
        <div class="ivyRecords" id="ivy" *ngIf="showData ==='ivy'">
            <div class="inputContainer">
                <div class="input-group tblSelect">
                    <button class="btn btn-primary audioTableSearchBtn"><i class="fa-solid fa-magnifying-glass"></i></button>
                    <input type="text" placeholder="Search" [(ngModel)]="searchText" class="form-control">
                </div>
            </div>
            <div class="table-responsive">
                <div class="card tblCrd">
                    <table class="table table-hover text-center">
                        <thead class="tblHead">
                            <tr class="text-center">
                                <th class="callLogHead">Comments Log</th>
                                <th>question answers</th>
                                <th>comments sentiment</th>
                                <th>action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let result of ivyTableData | search:searchText | paginate :{itemsPerPage:limit,
                                currentPage:page,
                                totalItems:ivyResult.total_records}; index as i" (click)="tableBack(i)"
                                [ngClass]="{'selectedClass':i===tableTrVar, 'unread': result.read==='N'}">
                                <td class="callLogTd" [ngClass]="{'callLogTd2':showModalAudioTag}">
                                    <span class="callLogs" *ngIf="i !== audioFileIndex">
                                        <i class="fa-regular fa-circle-play iconPlay" (click)="playAudioFile(i)"
                                            tooltip="Play" [options]="myOptions"></i>
                                        {{result.display_file_name}}
                                    </span>
                                    <i *ngIf="audioSpinner && i === audioFileIndex"
                                        class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                                    <audio [src]="audioSafeUrl" *ngIf="i === audioFileIndex"
                                        (play)="audioTagChange('play')" (pause)="audioTagChange('pause')"
                                        class="audio-file-class" id="audioTagAnalysis" controls>
                                    </audio>
                                    <i *ngIf="i === audioFileIndex" (click)="closeAudioTag()" title="close"
                                        class="fa-solid fa-xmark audioTagExitIcon" aria-label="Close"></i>
                                </td>
                                <td class="survey-fa-eye-table">
                                    <!-- <span class="callLogs" *ngIf="i !== audioFileIndex">
                                        <i class="fa-regular fa-circle-play iconPlay" (click)="playAudioFile(i)"
                                            tooltip="Play" [options]="myOptions"></i>
                                        {{result.display_file_name}}
                                    </span>
                                    <i *ngIf="audioSpinner && i === audioFileIndex"
                                        class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                                    <audio [src]="audioSafeUrl" *ngIf="i === audioFileIndex" (play)="audioTagChange('play')"
                                        (pause)="audioTagChange('pause')" class="audio-file-class" id="audioTagAnalysis"
                                        controls>
                                    </audio>
                                    <i *ngIf="i === audioFileIndex" (click)="closeAudioTag()" title="close"
                                        class="fa-solid fa-xmark audioTagExitIcon" aria-label="Close"></i> -->
                                    <i class="fa fa-eye surveyTableIcons" data-bs-toggle="modal"
                                        data-bs-target="#questionAnswerModal" tooltip="View Question Answers"
                                        [options]="myOptions" (click)="sendIndex(i)"></i>
                                </td>
                                <td class="text-center sentiment-icon">
                                    <span *ngIf="result[3].sequence === '3' && result[3]?.sentiment">
                                        <i class="fa-regular fa-face-smile surveyTableIcons iconSmile"
                                            (click)="sendIndex(i)" data-bs-toggle="modal"
                                            data-bs-target="#sentimentModal" [options]="myOptions"
                                            tooltip="View Sentiment Score" placement="top"
                                            *ngIf="result[3].sentiment.negative_sentiment < result[3].sentiment.positive_sentiment"></i>
                                        <i class="fa-regular fa-face-frown surveyTableIcons iconSad"
                                            (click)="sendIndex(i)" data-bs-toggle="modal"
                                            data-bs-target="#sentimentModal" [options]="myOptions"
                                            tooltip="View Sentiment Score" placement="top"
                                            *ngIf="result[3].sentiment.positive_sentiment < result[3].sentiment.negative_sentiment"></i>
                                        <i class="fa-regular fa-face-meh surveyTableIcons iconMeh"
                                            (click)="sendIndex(i)" data-bs-toggle="modal"
                                            data-bs-target="#sentimentModal" [options]="myOptions"
                                            tooltip="View Sentiment Score" placement="top"
                                            *ngIf="result[3].sentiment.positive_sentiment === result[3].sentiment.negative_sentiment"></i>
                                    </span>
                                    <span *ngIf="!result[3]?.sentiment">-</span>
                                </td>
                                <td class="actionTd">
                                    <i class="fa-solid fa-circle-info audioIcons iconAction" tooltip="File Info"
                                        [options]="myOptions"></i>
                                    <i class="fa-regular fa-trash-can audioIcons iconAction" tooltip="Delete Record"
                                        [options]="myOptions" *ngIf="usersRole !== 101"></i>
                                </td>
                            </tr>
                            <tr class="text-center" *ngIf="ivyTableData?.length === 0">
                                <td colspan="8" class="pad-10-0">
                                    <p class="mar-0">No Records here</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="paginationRecords" *ngIf="ivyTableData?.length > 0">
                <div class="row">
                    <div class="col-md-6 pagination-records">
                        <p>Showing {{ivyTableData?.length}} of {{ivyTableData?.length}} records</p>
                    </div>
                    <div class="col-md-6 text-right">
                        <div class="pgContainer">
                            <pagination-controls #pagination [maxSize]="7" [responsive]="true" [autoHide]="true"
                                [directionLinks]="true" (pageChange)="pageChanged($event)">
                            </pagination-controls>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Question Answer Modal Window -->
    <div class="modal fade" id="questionAnswerModal" tabindex="-1" aria-labelledby="questionAnswerModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="questionAnswerModalLabel">Question Answers</h4>
                    <i class="fa-solid fa-xmark exitIcon " (click)="clearQuestionAnswersData()" data-bs-dismiss="modal"
                        aria-label="Close"></i>
                </div>
                <div class="modal-body">
                    <div class="card modalCard">
                        <div class="card-body">
                            <table class="table table-bordered" *ngIf="showData === 'survey'">
                                <thead>
                                    <tr>
                                        <th>question</th>
                                        <th>answer</th>
                                        <th>score</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let data of questionAnswersData">
                                        <td>{{data.question}}</td>
                                        <td>{{data.answer}}</td>
                                        <td>{{data.actual_score}}</td>
                                    </tr>
                                    <tr *ngIf="questionAnswersData?.length === 0">
                                        <td class="text-center">No records here</td>
                                    </tr>
                                </tbody>
                            </table>
                            <table class="table table-bordered" *ngIf="showData === 'ivy'">
                                <thead>
                                    <tr>
                                        <th>Question Text</th>
                                        <th>Minimum Score</th>
                                        <th>Maximum Score</th>
                                        <th>Actual Score</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let data of questionAnswersData">
                                        <td>{{data.question_text}}</td>
                                        <td>{{data.min_score}}</td>
                                        <td>{{data.max_score}}</td>
                                        <td>{{data.actual_score}}</td>
                                    </tr>
                                    <tr *ngIf="questionAnswersData?.length === 0">
                                        <td class="text-center">No records here</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Sentiment Modal Window -->
    <div class="modal fade" id="sentimentModal" tabindex="-1" aria-labelledby="sentimentModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="sentimentModalLabel">Comments Sentiment</h4>
                    <i class="fa-solid fa-xmark exitIcon " (click)="clearQuestionAnswersData()" data-bs-dismiss="modal"
                        aria-label="Close"></i>
                </div>
                <div class="modal-body">
                    <!-- survey -->
                    <div class="card modalCard" *ngIf="showData === 'survey'">
                        <div class="sentiment-container-emoji">
                            <ul class="list-group list-group-horizontal border text-center">
                                <li class="list-group-item"
                                    *ngIf="sentimentData?.positive_sentiment > sentimentData?.negative_sentiment">
                                    <i class="fa-regular fa-face-smile iconSmile" aria-hidden="true"></i>
                                    <p class="sentiment-name">Positive</p>
                                </li>
                                <li class="list-group-item"
                                    *ngIf="sentimentData?.positive_sentiment < sentimentData?.negative_sentiment">
                                    <i class="fa-regular fa-face-frown iconSad" aria-hidden="true"></i>
                                    <p class="sentiment-name">Negative</p>
                                </li>
                                <li class="list-group-item"
                                    *ngIf="sentimentData?.positive_sentiment === sentimentData?.negative_sentiment">
                                    <i class="fa-regular fa-face-meh iconMeh" aria-hidden="true"></i>
                                    <p class="sentiment-name">Neutral</p>
                                </li>
                            </ul>
                        </div>
                        <div class="card-body">
                            <div class="table-responsive">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Comments</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td *ngIf="comments !== null">{{comments}}</td>
                                            <td *ngIf="comments === null" class="text-center">No Comments Here</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <!-- ivy -->
                    <div class="card modalCard" *ngIf="showData === 'ivy'">
                        <div class="sentiment-container-emoji">
                            <ul class="list-group list-group-horizontal border text-center"
                                [ngClass]="{'list-group-item-with-play-btn':showModalAudioTag && fileIndex === audioFileIndex}">
                                <div class="buttonSection d-flex"
                                    *ngIf="showModalAudioTag && fileIndex === audioFileIndex">
                                    <i class="fa fa-play play-icon-modal" (click)="playAD('play')"
                                        *ngIf="!showPlayPause" aria-hidden="true"> <span class="play-text">play</span>
                                    </i>
                                    <i class="fa fa-pause pause-icon-modal" (click)="playAD('pause')"
                                        *ngIf="showPlayPause" aria-hidden="true"></i>
                                    <div class="snippet" data-title="dot-typing" *ngIf="showPlayPause">
                                        <div class="stage">
                                            <div class="dot-typing"></div>
                                        </div>
                                    </div>
                                </div>
                                <li class="list-group-item"
                                    *ngIf="sentimentData?.sentiment?.positive_sentiment > sentimentData?.sentiment?.negative_sentiment">
                                    <i class="fa-regular fa-face-smile iconSmile" aria-hidden="true"></i>
                                    <p class="sentiment-name">Positive</p>
                                </li>
                                <li class="list-group-item"
                                    *ngIf="sentimentData?.sentiment?.positive_sentiment < sentimentData?.sentiment?.negative_sentiment">
                                    <i class="fa-regular fa-face-frown iconSad" aria-hidden="true"></i>
                                    <p class="sentiment-name">Negative</p>
                                </li>
                                <li class="list-group-item"
                                    *ngIf="sentimentData?.sentiment?.positive_sentiment === sentimentData?.sentiment?.negative_sentiment">
                                    <i class="fa-regular fa-face-meh iconMeh" aria-hidden="true"></i>
                                    <p class="sentiment-name">Neutral</p>
                                </li>
                            </ul>
                        </div>
                        <div class="card-body">
                            <div class="table-responsive">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Comments</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td *ngIf="comments !== null">{{comments}}</td>
                                            <td *ngIf="comments === null" class="text-center">No Comments Here</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>